import { StrictMode } from "react";
import { createRoot } from 'react-dom/client';
import { BrowserRouter  } from "react-router-dom";
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primeicons/primeicons.css';
import './app.scss';


import { AuthProvider } from "./hooks/useAuth";
import AppWrapper from './AppWrapper';

const root = createRoot(document.getElementById('root'));
root.render(
	<BrowserRouter >
		<AuthProvider>
			<AppWrapper />
		</AuthProvider>
	</BrowserRouter >
);

